<template>
  <el-config-provider :locale="locale">
    <router-view :key="key" />
  </el-config-provider>
  <CookieBox />
</template>

<script>
import { defineComponent } from "vue";
import { ElConfigProvider } from "element-plus";
import CookieBox from "@/components/common/CookieBox.vue";

import zhTw from "element-plus/dist/locale/zh-tw.mjs";

// element-plus 改成繁中語系
export default defineComponent({
  components: {
    ElConfigProvider,
    CookieBox
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
  setup() {
    return {
      locale: zhTw,
    };
  },
});
</script>
